module.exports = "/static/js/5821648ccb92e4e91461ea1fab7f6802.png";